module.exports = __webpack_public_path__ + "static/media/LV.16e708ba.png";